import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-entries.svg";
import * as styles from "./Icon.module.scss";

type EntriesProps = React.SVGProps<SVGSVGElement>;

export const Entries = ({ className, ...props }: EntriesProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
